<template lang="pug">
component(:is="componentIs")
  slot
</template>

<script setup lang="ts">
import type { Component } from "vue";
import { useHeadingLevel } from "../composables/headingLevel";

interface Props {
  /**
   * The HTML tag name to use for the section.
   */
  componentIs?: string | Component;

  /**
   * The relative heading level.
   */
  hLevel?: number;
}

const props = withDefaults(defineProps<Props>(), {
  componentIs: "div",
});

// Simply calling this composable increments the heading level for all children.
useHeadingLevel(props.hLevel);
</script>
